export enum OnboardingStep {
  CreateName = "CreateName",
  RobotIntro = "RobotIntro",
}
